import {FormControl, Checkbox, CheckboxGroup, Grid, Stack} from '@primer/react-brand'
import {getAnalyticsEvent} from '../../../../lib/utils/analytics'
import type {FormFieldCheckboxGroup} from '../../../../schemas/contentful/contentTypes/formFieldCheckboxGroup'
import styles from './ContentfulCheckboxGroupInput.module.css'

export type ContentfulCheckboxGroupProps = {
  component: FormFieldCheckboxGroup
}

/**
 * Utility to chunk an array into subarrays of specified size.
 */
function chunk<T>(arr: readonly T[], size: number): T[][] {
  const numChunks = Math.ceil(arr.length / size)
  const arrayLike = {length: numChunks} // Used with Array.from to build an array of a specific size

  // Slice a chunk of the specified size from given array
  const slicer = (_: undefined, i: number) => {
    const start = i * size
    const stop = start + size

    return arr.slice(start, stop)
  }

  return Array.from(arrayLike, slicer)
}

export function ContentfulCheckboxGroupInput({component: checkboxGroup}: ContentfulCheckboxGroupProps) {
  // Chunk the options into columns of 3
  const optionEntries = Object.entries(checkboxGroup.fields.options)
  const columns = chunk<[string, string]>(optionEntries, 3)

  return (
    <CheckboxGroup
      key={checkboxGroup.fields.htmlName}
      {...getAnalyticsEvent({
        action: checkboxGroup.fields.text,
        tag: 'checkbox-group',
        context: 'form_control',
        location: 'form',
      })}
    >
      <CheckboxGroup.Label>{checkboxGroup.fields.text}</CheckboxGroup.Label>

      <Grid className={styles.checkboxGrid}>
        {columns.map((columnOptions, colIdx) => (
          <Grid.Column span={6} key={`column-${columnOptions[0]?.[0] ?? colIdx}`}>
            <Stack direction="vertical" gap={8} padding="none">
              {columnOptions.map(([value, label]) => (
                <FormControl key={value} id={`checkbox-${checkboxGroup.fields.htmlName}-${value}`}>
                  <FormControl.Label>{label}</FormControl.Label>
                  <Checkbox name={`${checkboxGroup.fields.htmlName}[]`} value={value} />
                </FormControl>
              ))}
            </Stack>
          </Grid.Column>
        ))}
      </Grid>
    </CheckboxGroup>
  )
}

try{ ContentfulCheckboxGroupInput.displayName ||= 'ContentfulCheckboxGroupInput' } catch {}